import { configure } from "vee-validate/dist/vee-validate.full";
import i18n from "@/libs/i18n";

configure({
  defaultMessage: (field, values) => {
    return i18n.t(`validation.${values._rule_}`, values);
  },
});
